import { v4 as uuidv4 } from 'uuid'
import { NoteRoute } from '@/modules/note/v1/api/NoteRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { CreateUploadParams } from '@/modules/note/v1/api/v1/files/Dto/CreateUploadParams'
import { Upload } from '@/modules/note/v1/api/v1/files/Dto/Upload'

/** POST /api/note/v1/notes/{note}/uploads: открыть сессию загрузки файла в заметку */
export class CreateUploadRoute extends NoteRoute<CreateUploadParams, Upload> {
  constructor(private readonly note: string) {
    super()
  }

  type(): EnumRouteType {
    return EnumRouteType.POST
  }

  url(): string {
    return '/api/note/v1/notes/' + this.note + '/uploads'
  }

  offline(params: CreateUploadParams): Promise<ApiResponse<Upload>> {
    return Promise.resolve(new ApiResponse({ success: true, data: new Upload({ upload: uuidv4(), size: params.size, received: 0, file: null }) }))
  }
}
